import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { popupBot } from '../../actions';
import { ApiAiClient } from 'api-ai-javascript';
import { dataBaseManager } from '../hupUtils/utils';
import { scope, keyPrivate, iss, agentIdPopup } from '../../apis/stringConnection';
import { detectIntentText } from './dialogEfect';

let GAPI = require('gapitoken');

let timeoutLength = 10000;
let timeoutLengthG = 10000;
let timeouCurrent = 120000;
class notifiactions extends React.Component {

    state = { dia: [], etapa: 1, messages: null }

    componentDatabase(tipo, path, objectIn, message, messageError) {
        let men = dataBaseManager(tipo, path, objectIn, message, messageError);
        if (men && men.message)
            this.props.popupBot({ message: men.message });
        return men;
    }

    notificationPriority = () => {
        this.timeout = setTimeout(() => {
            timeoutLength = 9500;

            if (Object.keys(this.dia).length > 0) {
                this.dia['ultimaConexion'] = moment().format('x');
                this.dia['cantIn'] = this.dia.cantIn + 1;
                let ahora = moment().format('x');
                let dif = ahora - this.dia.entrada;
                this.obtenerPaso(dif);
                this.consultarmessages(this.state.messages, dif);
                this.notificationPriority();
            }
            else {
                this.dia['entrada'] = moment().format('x');
                this.dia['cantIn'] = 0;
             //   console.log(this.dia);
                timeoutLength = timeoutLengthG;
                this.notificationPriority();
            }

            this.componentDatabase('update', `Usuario-Dia/${this.props.userId}/${moment().format("YYYYMMDD")}`, {
                ...this.dia
            });
        }, timeoutLength)
    }


    organizarmessages(messages) {

        Object.keys(messages).sort((a, b) => (a.tiempo - b.tiempo));
        Object.keys(messages).map((key, index) => {
            this.etapas[messages[key].tiempo] = key;
            return messages[key];
        });

    }

    obtenerPaso(dif) {

        let flag = true;
        Object.keys(this.etapas).map((key, index) => {

            if (dif <= parseFloat(key) + 6000 && flag) {
                flag = false;
                this.setState({ etapa: this.etapas[key] })
            }
            return this.etapas[key];
        });
    }

    consultarmessages(messages, dif) {
        if (messages)
            Object.keys(messages).map((key, index) => {
                // console.log(key);
                if (key === this.state.etapa.toString()) {
                  /*  console.log('time message :');
                    console.log(parseFloat(messages[key].tiempo));
                    console.log('time current :');
                    console.log(dif);*/
                    if (dif <= parseFloat(messages[key].tiempo) + 6000 && dif >= parseFloat(messages[key].tiempo) - 6000) {
                    //    console.log(messages[key].message)
                        this.dia['etapa'] = this.state.etapa;
                        this.dia['etapas'] = this.dia['etapas'] !== undefined ? this.state.etapa + this.dia['etapas'] : this.state.etapa;

                        let men = [];
                        men["mensaje"] = messages[key].mensaje;
                        men["header"] = messages[key].header ? messages[key].header : null;
                        men["sleep"] = messages[key].sleep ? messages[key].sleep : null;
                        men["dormir"] = messages[key].dormir ? messages[key].dormir : null;
                        men["activate"] = messages[key].activate ? messages[key].activate : null;
                        men["chat"] = messages[key].chat ? messages[key].chat : null;
                        men["agent"] = messages[key].agent ? messages[key].agent : null;
                        men["previous"] = messages[key].previous ? messages[key].previous : null;
                        men["music"] = messages[key].music ? messages[key].music : null;
                        if (messages[key].video) {
                            men["link"] = messages[key].video;
                            men["video"] = true;
                            men["lection"] = messages[key].lection;

                        }
                        this.props.popupBot({ ...men });

                        // this.setState({ etapa: this.state.etapa + 1 });
                    }
                }
                return messages[key];
            });
    }

    componentDidMount() {
        this.sessionId = Math.round(Math.random() * 15000000);

        let gapi = new GAPI({
            iss: iss,
            scope: scope,
            key: keyPrivate
        }, () => {
            gapi.getToken((err, token) => {
                if (err) { console.log(err); }
                this.setState({ token });
            });
        });

        this.dia = [];
        this.etapas = [];
        const nameRef = this.componentDatabase('get', `Usuario-Dia/${this.props.userId}/${moment().format("YYYYMMDD")}`);
        nameRef.on('value', (snapshot2) => {
            if (snapshot2.val() !== null) {
                this.dia = snapshot2.val();
                this.setState({ etapa: snapshot2.val().etapa ? snapshot2.val().etapa : 1 });
            }

        });
    }

    renderStartDialog(arrayMessage) {
        if (arrayMessage !== null && arrayMessage.responseMessages !== undefined) {
            arrayMessage.responseMessages.map((item, i) => {
                if (!item.text) {
                    let nuevo = item.payload;
                  //  console.log(nuevo);
                    this.setState({ messages: nuevo });
                    this.organizarmessages(nuevo);
                }
            });
        }
    }

    async renderchatStart(text) {
        this.flagChat = true;
        detectIntentText(text, this.state.token, this.sessionId, agentIdPopup).then((response) => {
           
            this.renderStartDialog(response);
            this.notificationPriority();

        });

    }


    render() {
        if (this.flagChat === undefined && this.state.token)
            this.renderchatStart("hello");

        return (<div>
        </div>);
    }
};

const mapAppStateToProps = (state) => (
    {
        userId: state.mainReducer.userId,
    });


export default connect(mapAppStateToProps, { popupBot })(notifiactions);